import { render, staticRenderFns } from "./DeleteInvoiceButton.vue?vue&type=template&id=28d3c318&scoped=true&"
import script from "./DeleteInvoiceButton.vue?vue&type=script&lang=js&"
export * from "./DeleteInvoiceButton.vue?vue&type=script&lang=js&"
import style0 from "./DeleteInvoiceButton.vue?vue&type=style&index=0&id=28d3c318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d3c318",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28d3c318')) {
      api.createRecord('28d3c318', component.options)
    } else {
      api.reload('28d3c318', component.options)
    }
    module.hot.accept("./DeleteInvoiceButton.vue?vue&type=template&id=28d3c318&scoped=true&", function () {
      api.rerender('28d3c318', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMemberInvoices/buttons/DeleteInvoiceButton.vue"
export default component.exports